import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { sortBy } from '@paragon/utilities';

import { useAppSelector } from '../hooks';

export function ParentSelect(props: {
  optional?: boolean;
  label: string;

  includeLines?: boolean;
  includeDirectories?: boolean;

  parentGuid?: string;
  onChange: (parentGuid: string | null) => void;
}) {
  const linesState = useAppSelector((state) => state.lines);
  if (linesState.status !== 'loaded') {
    return (
      <FormControl fullWidth disabled>
        <InputLabel>loading...</InputLabel>
        <Select />
      </FormControl>
    );
  }

  let possibleParents = [] as { guid: string; name: string }[];

  if (props.includeLines) {
    possibleParents = possibleParents.concat(Object.values(linesState.lines));
  }

  if (props.includeDirectories) {
    possibleParents = possibleParents.concat(Object.values(linesState.directories));
  }

  possibleParents = sortBy(possibleParents, (candidate) => candidate.name);

  let { label } = props;
  if (props.optional) label += ' (optional)';

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={props.parentGuid ?? ''}
        onChange={(event) => {
          const selectedValue = event.target.value as string;
          props.onChange(selectedValue === '' ? null : selectedValue);
        }}
      >
        {props.optional && props.parentGuid && (
          <MenuItem key="none" value="">
            None
          </MenuItem>
        )}

        {possibleParents.map((candidate) => (
          <MenuItem key={candidate.guid} value={candidate.guid}>
            {candidate.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
